import authService from './authService';
import { readList, toQuery } from './apiResponse';
import type { EmailOutboxItem, EmailStatus } from '../types/planning';

/** Administração → E-mails (só admin): caixa de saída do app (Fase 8). Não há envio manual. */
class EmailService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /admin/emails?status=&limit=100 — mais recente primeiro (limite 1–500). */
  async list(status?: EmailStatus | '', limit = 100): Promise<EmailOutboxItem[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/admin/emails${toQuery({ status: status || undefined, limit })}`);
    return readList<EmailOutboxItem>(response, 'Falha ao listar os e-mails');
  }
}

export const emailService = new EmailService();
export default emailService;
